import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { DealersDashboardQueryKeys } from "modules/DealersDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

import type { TyreTeamCredential, TyreTeamCredentialID } from "models";

export type TyreTeamCredentialPayload = Omit<TyreTeamCredential, "id">;

export const useCreateTyreTeamCredentialMutation = () =>
  useTypedMutation<TyreTeamCredentialPayload, TyreTeamCredentialID>({
    mutationFn: async payload => (await ApiInstance.post("/credentials/create", payload, ENV.tyreTeamBaseURL)).data.id,
    onSuccess: (payload, id) => {
      const credentials = typedQueryClient.getQueryData(DealersDashboardQueryKeys.tyreTeamCredentials(payload.dealer_location_id));

      typedQueryClient.setQueryData(DealersDashboardQueryKeys.tyreTeamCredentials(payload.dealer_location_id), [...(credentials ?? []), { ...payload, id }]);
    }
  });
